import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState, DeviceSelection, ReportConfiguration } from '@nx-customer-apps/shared/interfaces';
import { AppSpecificDataSelectors } from './app-specific-data.selectors';
import { AppSpecificDataActions } from './app-specific-data.actions';

@Injectable({ providedIn: 'root' })
export class AppSpecificDataStore {
    private store$ = inject<Store<AppState>>(Store);

    public state$ = this.store$.pipe(select(AppSpecificDataSelectors.getState()));
    public viguidePlanningSpecificData$ = this.store$.pipe(select(AppSpecificDataSelectors.selectViguidePlanningSpecificData()));
    public reportConfiguration$ = this.store$.pipe(select(AppSpecificDataSelectors.selectReportConfiguration()));

    public setReportConfiguration(paylod: { reportConfiguration: ReportConfiguration[] }): void {
        this.store$.dispatch(AppSpecificDataActions.setReportConfiguration(paylod));
    }

    public setCalculationsData(paylod: { calculationsData: { deviceSelection: DeviceSelection } }): void {
        this.store$.dispatch(AppSpecificDataActions.setCalculationsData(paylod));
    }

    public setEnergyPricesVisited(paylod: { isEnergyPricesPageVisited: boolean }): void {
        this.store$.dispatch(AppSpecificDataActions.setEnergyPricesPageVisited(paylod));
    }
}
